/**
 * Normalizes a base URL by stripping trailing slashes and ensuring it ends with /api.
 * Used when resolving the API base URL in production.
 */
export function normalizeApiBaseUrl(url: string): string {
  const base = url.replace(/\/+$/, '')
  return base.endsWith('/api') ? base : `${base}/api`
}

/**
 * Resolves the API base URL: in development returns '/api' (for Vite proxy);
 * in production returns the normalized form of the given raw URL.
 */
export function resolveApiBaseUrl(isDev: boolean, rawUrl: string): string {
  return isDev ? '/api' : normalizeApiBaseUrl(rawUrl.trim())
}
